/* istanbul ignore next */
var env
if (window.location.href.includes('localhost')) {
  env = 'development'
} else if (window.location.href.includes('staging')) {
  env = 'staging'
} else {
  env = 'production'
}

var accessToken
if (env === 'staging') {
  accessToken = '188c134366684c6095032121c272e58c'
} else if (env === 'production') {
  accessToken = '4e1ee80cebdd494aa04a2cfaba7e28f5'
} else {
  accessToken = '0dd5ff186f824f57a161d94e7e09af4d'
}

var rollbarConfig = {
  accessToken: accessToken,
  captureUncaught: true,
  autoInstrument: true,
  payload: {
    environment: env,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
}

var Rollbar = require('./rollbar.umd.min.js')
export const rollbar = new Rollbar(rollbarConfig)



// WEBPACK FOOTER //
// ./src/rollbar.js